import { Component, EventEmitter, forwardRef, Inject, Injector, Input, Output, ViewChild } from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { FormControl, FormControlName, FormGroupDirective, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';
import { debounceTime, first, map, of } from 'rxjs';
import { sortSelectOptionsAscending } from '../select-v2/util/select-v2.util';
import { hasControlErrors, translateOptions } from '../../shared/services/select.utils';
import { DomHandler } from 'primeng/dom';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
import * as i2 from "@ngx-translate/core";
import * as i3 from "@angular/common";
import * as i4 from "primeng/autocomplete";
import * as i5 from "primeng/api";
import * as i6 from "../icon-v2/icon.component";
import * as i7 from "primeng/tooltip";
import * as i8 from "../field-error/field-error.component";
import * as i9 from "ngx-skeleton-loader";
import * as i10 from "../../shared/directive/tooltip-on-ellipsis-v2.directive";
/**
 * @deprecated use autocomplete select v3 component instead
 */
const _c0 = ["autocompleteComp"];
const _c1 = a0 => ({
  "dropdown-container-thin": a0
});
const _c2 = (a0, a1, a2) => ({
  "gea-always-float-label": a0,
  "dropdown-open": a1,
  "dropdown-upwards": a2
});
const _c3 = (a0, a1) => ({
  "ng-invalid ng-dirty": a0,
  "dropdown-thin": a1
});
const _c4 = (a0, a1) => ({
  "dropdown-open": a0,
  "icon-disabled-state": a1
});
const _c5 = a0 => ({
  "gea-select-label-disabled": a0
});
const _c6 = a0 => ({
  "gea-form-container-margin": a0
});
const _c7 = () => ({
  height: "40px",
  width: "100%"
});
function AutocompleteSelectV2Component_div_0_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const option_r3 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("pTooltip", (tmp_5_0 = i0.ɵɵpipeBind1(1, 2, option_r3.toolTipText)) !== null && tmp_5_0 !== undefined ? tmp_5_0 : option_r3.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(option_r3.name);
  }
}
function AutocompleteSelectV2Component_div_0_geaui_icon_v2_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 12);
    i0.ɵɵlistener("click", function AutocompleteSelectV2Component_div_0_geaui_icon_v2_7_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleClearInput());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c4, ctx_r1.isDropdownOpen, ctx_r1.isDisabled))("color", ctx_r1.isDisabled ? "grey" : "blue")("file", ctx_r1.removeIcon)("clickable", true);
  }
}
function AutocompleteSelectV2Component_div_0_label_9_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " *");
    i0.ɵɵelementEnd();
  }
}
function AutocompleteSelectV2Component_div_0_label_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 13);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, AutocompleteSelectV2Component_div_0_label_9_span_3_Template, 2, 0, "span", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("for", ctx_r1.formControlName + "labelId");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c5, ctx_r1.isDisabled));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, ctx_r1.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.required);
  }
}
function AutocompleteSelectV2Component_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "span", 4);
    i0.ɵɵlistener("click", function AutocompleteSelectV2Component_div_0_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClick());
    });
    i0.ɵɵelementStart(2, "p-autoComplete", 5, 1);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtwoWayListener("ngModelChange", function AutocompleteSelectV2Component_div_0_Template_p_autoComplete_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.currentlySelected, $event) || (ctx_r1.currentlySelected = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onLazyLoad", function AutocompleteSelectV2Component_div_0_Template_p_autoComplete_onLazyLoad_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLazyLoad.emit($event));
    })("completeMethod", function AutocompleteSelectV2Component_div_0_Template_p_autoComplete_completeMethod_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.filterOptions($event));
    })("onShow", function AutocompleteSelectV2Component_div_0_Template_p_autoComplete_onShow_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onShow());
    })("onSelect", function AutocompleteSelectV2Component_div_0_Template_p_autoComplete_onSelect_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelect($event));
    })("onClear", function AutocompleteSelectV2Component_div_0_Template_p_autoComplete_onClear_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClear());
    })("onHide", function AutocompleteSelectV2Component_div_0_Template_p_autoComplete_onHide_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onHide());
    })("onBlur", function AutocompleteSelectV2Component_div_0_Template_p_autoComplete_onBlur_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlur());
    })("onKeyUp", function AutocompleteSelectV2Component_div_0_Template_p_autoComplete_onKeyUp_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showClearButton());
    });
    i0.ɵɵtemplate(6, AutocompleteSelectV2Component_div_0_ng_template_6_Template, 3, 4, "ng-template", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, AutocompleteSelectV2Component_div_0_geaui_icon_v2_7_Template, 1, 7, "geaui-icon-v2", 7);
    i0.ɵɵelementStart(8, "geaui-icon-v2", 8);
    i0.ɵɵlistener("click", function AutocompleteSelectV2Component_div_0_Template_geaui_icon_v2_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleDropdown());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, AutocompleteSelectV2Component_div_0_label_9_Template, 4, 8, "label", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "geaui-field-error", 10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_10_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(36, _c1, ctx_r1.size === "small"));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("p-float-label", ctx_r1.floatLabelType === "auto");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(38, _c2, ctx_r1.alwaysFloatLabel, ctx_r1.isDropdownOpen, ctx_r1.isOpenedUpwards));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("inputId", ctx_r1.formControlName + "labelId");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.currentlySelected);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(42, _c3, ctx_r1.required && !ctx_r1.currentlySelected && ctx_r1.isDirty, ctx_r1.size === "small"))("appendTo", "body")("emptyMessage", i0.ɵɵpipeBind1(4, 30, (tmp_10_0 = ctx_r1.emptyMessageKey) !== null && tmp_10_0 !== undefined ? tmp_10_0 : "UI-LIB.AUTOCOMPLETE-SELECT.NO-RESULT-FOUND"))("showEmptyMessage", true)("readonly", ctx_r1.isDisabled || ctx_r1.isReadonly)("disabled", ctx_r1.isDisabled)("styleClass", ctx_r1.isDisabled ? "custom-disable" : "")("suggestions", ctx_r1.filteredOptions)("placeholder", i0.ɵɵpipeBind1(5, 32, ctx_r1.placeholder))("inputStyleClass", ctx_r1.isDropdownOpen ? "dropdown-open" : "")("forceSelection", true)("overlayOptions", ctx_r1.getOverlayOptions())("virtualScroll", ctx_r1.virtualScroll)("virtualScrollItemSize", ctx_r1.virtualScrollItemSize)("virtualScrollOptions", ctx_r1.virtualScrollOptions)("lazy", ctx_r1.lazy);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.isShowClearButton && !ctx_r1.isDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(45, _c4, ctx_r1.isDropdownOpen, ctx_r1.isDisabled))("color", ctx_r1.isDisabled ? "grey" : "blue")("file", ctx_r1.isDropdownOpen ? ctx_r1.searchIcon : ctx_r1.closeIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.floatLabelType === "auto");
    i0.ɵɵadvance();
    i0.ɵɵproperty("fieldName", i0.ɵɵpipeBind1(11, 34, ctx_r1.label))("submitted", ctx_r1.submitted)("errors", ctx_r1.inputControl == null ? null : ctx_r1.inputControl.errors);
  }
}
function AutocompleteSelectV2Component_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c6, ctx_r1.size !== "small"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(4, _c7));
  }
}
export class AutocompleteSelectV2Component {
  formBuilder;
  translateService;
  destroyed;
  injector;
  formControlName = 'autocomplete-select';
  autoselectGroup;
  label = '';
  placeholder = '';
  size = 'medium';
  required = false;
  autoDisplayFirst = false;
  loading = false;
  _options = [];
  set options(input) {
    if (input) {
      this._options = input;
      translateOptions(sortSelectOptionsAscending(this.options), this.translateService);
      if (this.currentlySelected) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const option = this.findSelectedOption(this.currentlySelected ?? null);
        if (option) this.writeValue(option);
      }
    }
  }
  get options() {
    return this._options;
  }
  get isDisabled() {
    return !!this.autoselectGroup.get(this.formControlName)?.disabled;
  }
  disabled;
  selected = null;
  floatLabelType = 'auto';
  alwaysFloatLabel = false;
  validationsError = 'UI-LIB.GENERAL.SELECT-ERROR';
  submitted = false;
  emptyMessageKey = 'UI.LIB.AUTOCOMPLETE-SELECT.NO-RESULT-FOUND';
  preFilter = () => {
    return of(this.options);
  };
  virtualScroll = false;
  virtualScrollItemSize;
  virtualScrollOptions;
  lazy = false;
  // keeping the property name as onLazyLoad to match the primeNG event name
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  onLazyLoad = new EventEmitter();
  selectChanged = new EventEmitter();
  autocompleteControl;
  autocompleteForm;
  removeIcon = '16px_close';
  searchIcon = '16px_search';
  closeIcon = '16px_chevron-down';
  filteredOptions = [];
  inputCleared = false;
  isDropdownOpen = false;
  isOpenedUpwards = false;
  _inputControl;
  isReadonly = false;
  currentlySelected = null;
  isShowClearButton = false;
  isDirty = false;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  prevValue;
  touched;
  onChange;
  constructor(formBuilder, translateService, destroyed, injector) {
    this.formBuilder = formBuilder;
    this.translateService = translateService;
    this.destroyed = destroyed;
    this.injector = injector;
    this.autoselectGroup = this.formBuilder.group({
      [this.formControlName]: new FormControl(this.selected)
    });
  }
  ngOnInit() {
    this.autoselectGroup.setControl(this.formControlName, new FormControl(this.selected));
    this.setFormControl();
    if (this.selected) this.setSelectedValue(this.selected);
    if (this.disabled) {
      this.setDisabledState(this.disabled);
    }
    this.inputControl?.registerOnDisabledChange(isDisabled => {
      this.setDisabledState(isDisabled);
    });
    if (this.required) {
      this.inputControl?.setValidators([Validators.required]);
      this.inputControl?.statusChanges?.subscribe({
        next: v => {
          if (v === 'INVALID') {
            this.setFormValidation(false);
          } else if (v === 'VALID' && this.autocompleteForm?.control?.status === 'INVALID') {
            this.setFormValidation(true);
          }
        }
      });
    }
    this.translateService.onLangChange.pipe(takeUntilDestroyed(this.destroyed)).subscribe(() => {
      translateOptions(this.options, this.translateService);
      const value = this._inputControl?.value;
      if (value) {
        this.currentlySelected = null;
        setTimeout(() => this.setSelectedValue(value));
      }
    });
  }
  ngAfterViewInit() {
    window.addEventListener('resize', this.alignOverlayPanel.bind(this));
    document.addEventListener('scroll', this.alignOverlayPanel.bind(this), true);
  }
  ngOnChanges(changes) {
    if (this.disabled) {
      this.setDisabledState(this.disabled);
    }
    if (changes?.['options'] && this.options) {
      translateOptions(sortSelectOptionsAscending(this.options), this.translateService);
      if (this._inputControl?.value) {
        this.writeValue(this._inputControl?.value);
      }
    }
    if (changes?.['selected'] && !changes?.['selected'].firstChange) {
      const currentSelectOption = changes?.['selected'].currentValue;
      this.setSelectedValue(currentSelectOption.value);
    }
  }
  setFormControl() {
    try {
      const formControl = this.injector.get(NgControl);
      if (formControl.constructor === FormControlName) {
        this._inputControl = this.injector.get(FormGroupDirective).getControl(formControl);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.info("Injecting NgControl didn't work, a default control will be used");
      this._inputControl = new FormControl();
    }
  }
  get inputControl() {
    return this._inputControl;
  }
  hasErrors() {
    return hasControlErrors(this.inputControl ?? null);
  }
  filterOptions(event) {
    const query = event?.query?.toLowerCase() ?? '';
    // Use Query for Request
    this.preFilter(query, this.options).pipe(debounceTime(500), first(), map(options => {
      translateOptions(options, this.translateService);
      return sortSelectOptionsAscending(options);
    })).subscribe(options => {
      if (query === '') {
        this.filteredOptions = [...options];
      } else {
        this.filteredOptions = options.filter(option => option.name?.toLowerCase().includes(query.toLowerCase()));
      }
      this.alignOverlayPanel();
    });
  }
  onSelect(event) {
    const value = event.value.value;
    this.selectChanged.emit(value);
    this.isShowClearButton = true;
    this.setSelectedValue(value);
  }
  onHide() {
    // Keep dropdown open if input got cleared and show all options
    if (this.inputCleared) {
      this.isDropdownOpen = true;
      this.autocompleteControl?.show(true);
      this.filterOptions();
      if (this.onChange) this.onChange(null);
      this.inputCleared = false;
    } else {
      this.isDropdownOpen = false;
    }
    if (this.hasErrors() && this.autocompleteForm?.status !== null) {
      this.setFormValidation(true);
    }
  }
  toggleDropdown() {
    if (this.isDisabled) return;
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.autocompleteControl?.show(true);
      this.filterOptions();
      this.alignOverlayPanel();
    } else {
      this.autocompleteControl?.hide();
    }
  }
  setSelectedValue(selectValue) {
    if (selectValue) {
      const option = this.findSelectedOption(selectValue);
      const valueToUpdate = option?.value ?? selectValue;
      if (this.onChange && valueToUpdate) this.onChange(valueToUpdate);
      this.writeValue(valueToUpdate);
    } else {
      // eslint-disable-next-line no-console
      console.error(`No control found`);
    }
  }
  findSelectedOption(value) {
    if (value) {
      return this.options.find(opt => value === opt.value);
    }
  }
  ngOnDestroy() {
    window.removeEventListener('resize', this.alignOverlayPanel.bind(this));
    document.removeEventListener('scroll', this.alignOverlayPanel.bind(this));
  }
  // function called whenever value changes, fire change detection
  registerOnChange(fn) {
    this.onChange = fn;
    if (this.selected) this.setSelectedValue(this.selected);
  }
  // control losing focus
  registerOnTouched(fn) {
    this.touched = fn;
  }
  // called on initialize, patchValue or setValue
  writeValue(value) {
    if (!value) {
      return;
    }
    this.isShowClearButton = true;
    this.prevValue = value;
    if (this.options.length > 0) {
      const selectOption = this.findMatchingOption(value);
      if (selectOption) {
        this.prevValue = selectOption;
        this.currentlySelected = selectOption;
      }
    } else {
      const valueToPatch = typeof value === 'string' ? value : value['value'] ?? undefined;
      if (valueToPatch) {
        this.currentlySelected = valueToPatch;
      }
    }
  }
  setDisabledState(isDisabled) {
    const control = this.autoselectGroup.get(this.formControlName);
    if (control?.disabled === isDisabled) {
      return;
    }
    isDisabled ? control?.disable() : control?.enable();
    if (this.inputControl?.disabled !== isDisabled) {
      isDisabled ? this.inputControl?.disable() : this.inputControl?.enable();
    }
  }
  findMatchingOption(value) {
    return this.options.find(o => o?.value === value || o?.name === value || o?.name === value['name']);
  }
  handleClearInput() {
    this.currentlySelected = null;
    this.isShowClearButton = false;
    this.alignOverlayPanel();
    this.selectChanged.emit(undefined);
    this._inputControl?.patchValue(null);
  }
  onClear() {
    this.inputCleared = true;
    this.touchControlAndCheckErrors();
  }
  onBlur() {
    this.touchControlAndCheckErrors();
    this.isDirty = true;
  }
  touchControlAndCheckErrors() {
    const control = this.autoselectGroup.get(this.formControlName);
    if (control) {
      control.markAsTouched();
      this.setFormValidation(this.hasErrors());
    }
  }
  showClearButton() {
    this.isShowClearButton = true;
  }
  onClick() {
    if (this.isDisabled) return;
    this.isReadonly = false;
    this.filterOptions();
    if (!this.isDropdownOpen) {
      this.isDropdownOpen = true;
      this.autocompleteControl?.show(true);
      this.alignOverlayPanel();
    }
  }
  onShow() {
    // Added timeout to make sure the dropdown is open before checking the position. Primeng has a delay in opening the dropdown. Possible a bug in primeng.
    setTimeout(() => {
      this.checkDropdownUpwardsOpen();
    }, 0);
  }
  setFormValidation(hasErrors) {
    const control = this.autoselectGroup.get(this.formControlName);
    if (control?.touched) {
      control.setErrors(hasErrors ? {
        invalid: true
      } : null);
    }
  }
  checkDropdownUpwardsOpen() {
    const dropdownPanels = document.body.querySelectorAll('.p-overlay');
    dropdownPanels.forEach(panel => {
      this.isOpenedUpwards = panel.style.transformOrigin === 'center bottom';
    });
  }
  getOverlayOptions() {
    return {
      listener: (event, options) => {
        if (options?.type === 'scroll' || options?.type === 'resize') {
          return false;
        }
        return options?.valid;
      }
    };
  }
  alignOverlayPanel() {
    if (!this.isDropdownOpen) {
      return;
    }
    const elements = document.body.getElementsByClassName('p-overlay');
    if (elements.length > 0) {
      const overlay = elements[0];
      DomHandler.alignOverlay(overlay, this.autocompleteControl?.containerEL?.nativeElement, document.body);
    }
    this.checkDropdownUpwardsOpen();
  }
  static ɵfac = function AutocompleteSelectV2Component_Factory(t) {
    return new (t || AutocompleteSelectV2Component)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i0.DestroyRef), i0.ɵɵdirectiveInject(Injector));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AutocompleteSelectV2Component,
    selectors: [["geaui-autocomplete-select-v2"]],
    viewQuery: function AutocompleteSelectV2Component_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(AutoComplete, 5);
        i0.ɵɵviewQuery(_c0, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteControl = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteForm = _t.first);
      }
    },
    inputs: {
      formControlName: "formControlName",
      label: "label",
      placeholder: "placeholder",
      size: "size",
      required: "required",
      autoDisplayFirst: "autoDisplayFirst",
      loading: "loading",
      options: "options",
      disabled: "disabled",
      selected: "selected",
      floatLabelType: "floatLabelType",
      alwaysFloatLabel: "alwaysFloatLabel",
      validationsError: "validationsError",
      submitted: "submitted",
      emptyMessageKey: "emptyMessageKey",
      preFilter: "preFilter",
      virtualScroll: "virtualScroll",
      virtualScrollItemSize: "virtualScrollItemSize",
      virtualScrollOptions: "virtualScrollOptions",
      lazy: "lazy"
    },
    outputs: {
      onLazyLoad: "onLazyLoad",
      selectChanged: "selectChanged"
    },
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => AutocompleteSelectV2Component)
    }]), i0.ɵɵNgOnChangesFeature],
    decls: 3,
    vars: 2,
    consts: [["skeleton", ""], ["autocompleteComp", "ngModel"], ["class", "gea-form-container-margin gea-autocomplete-select-container", 3, "ngClass", 4, "ngIf", "ngIfElse"], [1, "gea-form-container-margin", "gea-autocomplete-select-container", 3, "ngClass"], [3, "click", "ngClass"], ["optionLabel", "name", "dataKey", "value", "data-cy", "autocomplete", 3, "ngModelChange", "onLazyLoad", "completeMethod", "onShow", "onSelect", "onClear", "onHide", "onBlur", "onKeyUp", "ngModel", "ngClass", "appendTo", "emptyMessage", "showEmptyMessage", "readonly", "disabled", "styleClass", "suggestions", "placeholder", "inputStyleClass", "forceSelection", "overlayOptions", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "lazy", "inputId"], ["pTemplate", "item"], ["class", "autocomplete-select-dropdown-icons remove-icon", 3, "ngClass", "color", "file", "clickable", "click", 4, "ngIf"], [1, "autocomplete-select-dropdown-icons", 3, "click", "ngClass", "color", "file"], ["data-cy", "label", 3, "ngClass", "for", 4, "ngIf"], [3, "fieldName", "submitted", "errors"], ["data-cy", "option", "geauiTooltipOnEllipsisV2", "", 1, "pointer-events-auto", 3, "pTooltip"], [1, "autocomplete-select-dropdown-icons", "remove-icon", 3, "click", "ngClass", "color", "file", "clickable"], ["data-cy", "label", 3, "ngClass", "for"], [4, "ngIf"], [3, "ngClass"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function AutocompleteSelectV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, AutocompleteSelectV2Component_div_0_Template, 12, 48, "div", 2)(1, AutocompleteSelectV2Component_ng_template_1_Template, 2, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const skeleton_r5 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.loading)("ngIfElse", skeleton_r5);
      }
    },
    dependencies: [i3.NgClass, i3.NgIf, i4.AutoComplete, i5.PrimeTemplate, i6.IconComponent, i7.Tooltip, i1.NgControlStatus, i8.FieldErrorComponent, i9.NgxSkeletonLoaderComponent, i1.NgModel, i10.TooltipOnEllipsisV2Directive, i2.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutocompleteSelectV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-autocomplete-select-v2',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: forwardRef(() => AutocompleteSelectV2Component)
      }],
      template: "<div\n  class=\"gea-form-container-margin gea-autocomplete-select-container\"\n  *ngIf=\"!loading; else skeleton\"\n  [ngClass]=\"{ 'dropdown-container-thin': size === 'small' }\">\n  <span\n    [class.p-float-label]=\"floatLabelType === 'auto'\"\n    [ngClass]=\"{\n      'gea-always-float-label': alwaysFloatLabel,\n      'dropdown-open': isDropdownOpen,\n      'dropdown-upwards': isOpenedUpwards,\n    }\"\n    (click)=\"onClick()\">\n    <p-autoComplete\n      #autocompleteComp=\"ngModel\"\n      [(ngModel)]=\"currentlySelected\"\n      [ngClass]=\"{ 'ng-invalid ng-dirty': required && !currentlySelected && isDirty, 'dropdown-thin': size === 'small' }\"\n      [appendTo]=\"'body'\"\n      [emptyMessage]=\"emptyMessageKey ?? 'UI-LIB.AUTOCOMPLETE-SELECT.NO-RESULT-FOUND' | translate\"\n      [showEmptyMessage]=\"true\"\n      [readonly]=\"isDisabled || isReadonly\"\n      [disabled]=\"isDisabled\"\n      [styleClass]=\"isDisabled ? 'custom-disable' : ''\"\n      [suggestions]=\"filteredOptions\"\n      [placeholder]=\"placeholder | translate\"\n      [inputStyleClass]=\"isDropdownOpen ? 'dropdown-open' : ''\"\n      [forceSelection]=\"true\"\n      [overlayOptions]=\"getOverlayOptions()\"\n      [virtualScroll]=\"virtualScroll\"\n      [virtualScrollItemSize]=\"virtualScrollItemSize\"\n      [virtualScrollOptions]=\"virtualScrollOptions\"\n      [lazy]=\"lazy\"\n      (onLazyLoad)=\"onLazyLoad.emit($event)\"\n      (completeMethod)=\"filterOptions($event)\"\n      (onShow)=\"onShow()\"\n      (onSelect)=\"onSelect($event)\"\n      (onClear)=\"onClear()\"\n      (onHide)=\"onHide()\"\n      (onBlur)=\"onBlur()\"\n      (onKeyUp)=\"showClearButton()\"\n      inputId=\"{{ formControlName + 'labelId' }}\"\n      optionLabel=\"name\"\n      dataKey=\"value\"\n      data-cy=\"autocomplete\">\n      <ng-template let-option pTemplate=\"item\">\n        <span\n          class=\"pointer-events-auto\"\n          data-cy=\"option\"\n          geauiTooltipOnEllipsisV2\n          pTooltip=\"{{ (option.toolTipText | translate) ?? option.name }}\"\n          >{{ option.name }}</span\n        >\n      </ng-template>\n    </p-autoComplete>\n\n    <geaui-icon-v2\n      class=\"autocomplete-select-dropdown-icons remove-icon\"\n      *ngIf=\"isShowClearButton && !isDisabled\"\n      [ngClass]=\"{ 'dropdown-open': isDropdownOpen, 'icon-disabled-state': isDisabled }\"\n      [color]=\"isDisabled ? 'grey' : 'blue'\"\n      [file]=\"removeIcon\"\n      [clickable]=\"true\"\n      (click)=\"handleClearInput()\">\n    </geaui-icon-v2>\n    <geaui-icon-v2\n      class=\"autocomplete-select-dropdown-icons\"\n      [ngClass]=\"{ 'dropdown-open': isDropdownOpen, 'icon-disabled-state': isDisabled }\"\n      [color]=\"isDisabled ? 'grey' : 'blue'\"\n      [file]=\"isDropdownOpen ? searchIcon : closeIcon\"\n      (click)=\"toggleDropdown()\">\n    </geaui-icon-v2>\n    <label\n      *ngIf=\"floatLabelType === 'auto'\"\n      [ngClass]=\"{ 'gea-select-label-disabled': isDisabled }\"\n      for=\"{{ formControlName + 'labelId' }}\"\n      data-cy=\"label\">\n      {{ label | translate }}\n      <span *ngIf=\"required\"> *</span>\n    </label>\n  </span>\n  <geaui-field-error [fieldName]=\"label | translate\" [submitted]=\"submitted\" [errors]=\"inputControl?.errors\"></geaui-field-error>\n</div>\n\n<ng-template #skeleton>\n  <div [ngClass]=\"{ 'gea-form-container-margin': size !== 'small' }\">\n    <ngx-skeleton-loader [theme]=\"{ height: '40px', width: '100%' }\" count=\"1\" appearance=\"line\"></ngx-skeleton-loader>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i2.TranslateService
  }, {
    type: i0.DestroyRef
  }, {
    type: i0.Injector,
    decorators: [{
      type: Inject,
      args: [Injector]
    }]
  }], {
    formControlName: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    autoDisplayFirst: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    floatLabelType: [{
      type: Input
    }],
    alwaysFloatLabel: [{
      type: Input
    }],
    validationsError: [{
      type: Input
    }],
    submitted: [{
      type: Input
    }],
    emptyMessageKey: [{
      type: Input
    }],
    preFilter: [{
      type: Input
    }],
    virtualScroll: [{
      type: Input
    }],
    virtualScrollItemSize: [{
      type: Input
    }],
    virtualScrollOptions: [{
      type: Input
    }],
    lazy: [{
      type: Input
    }],
    onLazyLoad: [{
      type: Output
    }],
    selectChanged: [{
      type: Output
    }],
    autocompleteControl: [{
      type: ViewChild,
      args: [AutoComplete]
    }],
    autocompleteForm: [{
      type: ViewChild,
      args: ['autocompleteComp']
    }]
  });
})();
